<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Portfolio Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/projects/contracts'"
            >Contracts</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link to="" style="color: #8cc63f !important">
            Update
          </router-link>
        </li>
      </ol>
    </div>
    <div class="col-12" style="margin-top: 60px">
      <contract-form
        formType="update"
        contractType="ProjectContract"
        :activeContractID="activeContractID"
        @saveContract="updateContract"
      ></contract-form>
    </div>
  </div>
</template>
<script>
import ContractForm from "./forms/contractForm.vue";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
export default {
  data() {
    return {
      validationMsg: null,
      activeContractID: null,
    };
  },
  created: function () {
    this.activeContractID = this.$route.params.contractId;
  },
  components: {
    ContractForm,
  },
  methods: {
    formValidation(contract) {
      const result = { isValid: true, message: "" };
      result.message += "Please fill all required fields";
      let missingFieldsString = "";
      let statusList = ["active", "inactive", "notstarted", "closed"];
      let paymentTypes = ["cash", "banktransfer", "cheque", "blockchain"];

      if (!contract.start_date) {
        missingFieldsString += "Contract start date is not selected, ";
        result.isValid = false;
      }
      if (!contract.maturity_date) {
        missingFieldsString += "Contract maturity date is not selected, ";
        result.isValid = false;
      }
      if (!contract.project_id) {
        missingFieldsString += "Project is not selected, ";
        result.isValid = false;
      }
      if (!contract.plan_id) {
        missingFieldsString += "Plan is not selected, ";
        result.isValid = false;
      }
      if (!contract.invested_principal) {
        missingFieldsString += "Principal field is empty, ";
        result.isValid = false;
      }
      if (!statusList.includes(contract.payment_type)) {
        missingFieldsString += "Contract status should be selected, ";
        result.isValid = false;
      }
      if (!paymentTypes.includes(contract.status)) {
        missingFieldsString += "Contract payment should be selected, ";
        result.isValid = false;
      }
      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        result.message += ` (${missingFieldsString})`;
      }
      return result;
    },
    updateContract(contract) {
      const { isValid, message } = this.formValidation(contract);
      if (!isValid) {
        sweetAlert({
          title: "Error",
          text: message,
          type: "error",
          confirmButtonText: "Return",
        });
        return;
      }
      this.$store.dispatch("updateProjectContract", contract);
    },
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      updatedProjectContract: (state) =>
        state.contractStore.projectContractUpdate.updatedProjectContract,
      updateProjectContractStatus: (state) =>
        state.contractStore.projectContractUpdate.updateProjectContractStatus,
    }),
  },
  watch: {
    updateProjectContractStatus() {
      if (this.updateProjectContractStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Contract has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push(
            "/" + this.authUser.userable_type + "/projects/contracts"
          );
        });
      } else if (this.updateProjectContractStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Contract update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/updateProjectContract.vue